import { CoreCustomization } from "./core/coreCustomization";
import {
    LiteListFrameCustomization,
} from "./LiteListFrame/LiteListFrameCustomization";

export class Customization {
    public readonly liteListFrame = new LiteListFrameCustomization();
    public readonly core = new CoreCustomization();
}
let _customization: Customization;

/**
 * Vrací singleton instanci customization. V této instanci můžete konkrétním registrátorům zaregistrovat
 * nové renderery a modifikovat tak zobrazení danýcg customizovatelných bodů.
 *
 * @returns Instanci Customization.
 */
export const getCustomization = (): Customization => {
    if (!_customization) {
        _customization = new Customization();
    }
    return _customization;
};
